import { createFileRoute } from "@tanstack/react-router";
import { PortfolioPage } from "../../features/portfolio/pages/portfolio-page";

export const Route = createFileRoute("/_layout/portfolio")({
  component: PortfolioPage,
});
